/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  CreateDepositResponse,
  CreateDepositRequest
} from './schema'



export const utxDigitalDepositCreateDepositRequest = (
    createDepositRequest: CreateDepositRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateDepositResponse>> => {
    return axios.post(
      `/digital-deposit`,
      createDepositRequest,options
    );
  }



    export type UtxDigitalDepositCreateDepositRequestMutationResult = NonNullable<Awaited<ReturnType<typeof utxDigitalDepositCreateDepositRequest>>>
    export type UtxDigitalDepositCreateDepositRequestMutationBody = CreateDepositRequest
    export type UtxDigitalDepositCreateDepositRequestMutationError = AxiosError<unknown>

    export const useUtxDigitalDepositCreateDepositRequest = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxDigitalDepositCreateDepositRequest>>, TError,{data: CreateDepositRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxDigitalDepositCreateDepositRequest>>, {data: CreateDepositRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxDigitalDepositCreateDepositRequest(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxDigitalDepositCreateDepositRequest>>, TError, {data: CreateDepositRequest}, TContext>(mutationFn, mutationOptions)
    }
    